import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/utils/cn';


interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  onClick?: () => void;
}

export const GlassCard: React.FC<GlassCardProps> = ({ 
  children, 
  className = '',
  hover = true,
  onClick
}) => {
  return (
    <motion.div
      className={cn(
        'glass-card relative overflow-hidden',
        onClick && 'cursor-pointer',
        className
      )}
      style={{
        background: 'var(--season-glass, rgba(255, 255, 255, 0.08))',
        borderColor: 'var(--season-glass-border, rgba(255, 255, 255, 0.15))',
        boxShadow: 'var(--season-shadow, 0 8px 32px rgba(0, 0, 0, 0.2))',
      }}
      whileHover={hover ? { 
        y: -5,
        scale: 1.02,
        transition: { duration: 0.2 }
      } : undefined}
      whileTap={onClick ? { scale: 0.98 } : undefined}
      onClick={onClick}
    >
      {/* Gradient overlay */}
      <div 
        className="absolute inset-0 bg-gradient-to-br pointer-events-none"
        style={{
          background: 'var(--season-overlay-gradient, linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, transparent 100%))'
        }}
      />
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
      
      {/* Shimmer effect */}
      <div 
        className="absolute inset-0 bg-gradient-to-r from-transparent to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000"
        style={{
          background: 'linear-gradient(90deg, transparent, var(--season-primary, rgba(255, 255, 255, 0.1)), transparent)'
        }}
      />
    </motion.div>
  );
}; 